import { render, staticRenderFns } from "./TabViewer.vue.js?vue&type=template&id=76e64800&scoped=true!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.110.0__ejs@3.1.10_lodash@4.18.1_vue-temp_a1a6c39b28b04a0600f76b892a3b9cb0/node_modules/vue-loader/lib/index.js??vue-loader-options!./TabViewer.vue?vue&type=template&id=76e64800&scoped=true"
import script from "./TabViewer.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.110.0__ejs@3.1.10_lodash@4.18.1_vue-temp_a1a6c39b28b04a0600f76b892a3b9cb0/node_modules/vue-loader/lib/index.js??vue-loader-options!./TabViewer.vue?vue&type=script&lang=js"
export * from "./TabViewer.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.110.0__ejs@3.1.10_lodash@4.18.1_vue-temp_a1a6c39b28b04a0600f76b892a3b9cb0/node_modules/vue-loader/lib/index.js??vue-loader-options!./TabViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.110.0__ejs@3.1.10_lodash@4.18.1_vue-temp_a1a6c39b28b04a0600f76b892a3b9cb0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e64800",
  null
  
)

export default component.exports